import { ChevronLeft, Menu } from "lucide-react";
import { Box, Drawer, IconButton } from "@mui/material";
import { Dispatch, SetStateAction, useState } from "react";
import HeaderList from "./HeaderList";
import styles from "./HeaderMobile.module.css";
import NotLoggedInHeaderList from "./NotLoggedInHeaderList";
import { LoginDialogMode } from "../../../Account/Account.types";

export type IHeaderMobileProps =
    | {
          isLoggedIn: true;
          handleBookingAction: (route: string) => void;
          setShowLoginDialog?: Dispatch<SetStateAction<LoginDialogMode>>;
          setShowRegisterDialog?: Dispatch<SetStateAction<LoginDialogMode>>;
      }
    | {
          isLoggedIn: false;
          setShowLoginDialog: Dispatch<SetStateAction<LoginDialogMode>>;
          setShowRegisterDialog: Dispatch<SetStateAction<LoginDialogMode>>;
          handleBookingAction: (route: string) => void;
      };

export default function HeaderMobile({
    isLoggedIn,
    handleBookingAction,
    setShowLoginDialog,
    setShowRegisterDialog,
}: Readonly<IHeaderMobileProps>) {
    const [open, setOpen] = useState(false);
    const toggleDrawer = (newOpen: boolean) => {
        setOpen(newOpen);
    };

    return (
        <Box data-test-id="header_mobile" className={styles.header}>
            <IconButton data-test-id="icon_button_user_action_menu" color="primary" onClick={() => toggleDrawer(true)}>
                <Menu size={20} strokeWidth={2} aria-hidden />
            </IconButton>
            <Drawer open={open} onClose={() => toggleDrawer(false)}>
                <Box sx={{ width: "100vw", height: "100vh" }}>
                    <Box className={styles.headerDrawer}>
                        <IconButton
                            data-test-id="icon_button_user_action_menu_close"
                            color="primary"
                            onClick={() => toggleDrawer(false)}
                            sx={{ marginLeft: "auto" }}
                        >
                            <ChevronLeft size={20} strokeWidth={2} aria-hidden />
                        </IconButton>
                    </Box>
                    {isLoggedIn ? (
                        <HeaderList handleClose={() => toggleDrawer(false)} />
                    ) : (
                        <NotLoggedInHeaderList
                            toggleDrawer={toggleDrawer}
                            handleLogin={setShowLoginDialog}
                            handleRegister={setShowRegisterDialog}
                            handleBookingAction={handleBookingAction}
                        />
                    )}
                </Box>
            </Drawer>
        </Box>
    );
}
